export const numTicketsStateSelector = (state) => state.numTickets;
